import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import '../../../assets/css/Country/AddCountry.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
const API_BASE_URL = process.env.REACT_APP_API_URL;
const AddCountry = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');

  const [formData, setFormData] = useState({
    name: '',
    code: '',
    remarks: '',
    status: true,
  });

  // Fetch existing country for edit
  useEffect(() => {
    if (id) {
      axios.get(`${API_BASE_URL}/api/countries/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then((res) => setFormData(res.data))
        .catch((err) => {
          console.error('Error fetching country:', err);
          alert('Failed to load country data');
        });
    }
  }, [id, token]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        ...(id ? { updatedBy: userId } : { createdBy: userId }),
      };

      if (id) {
        await axios.put(`${API_BASE_URL}/api/countries/${id}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        // alert('Country updated successfully');
      } else {
        await axios.post(`${API_BASE_URL}/api/countries`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        // alert('Country added successfully');
      }

      navigate('/country');
    } catch (err) {
      console.error('Error saving country:', err);
      alert('Failed to save country');
    }
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="form-top-title">{id ? 'Edit Country' : 'Add Country'}</h4>
        <button
          className="btn btn-outline-dark"
          onClick={() => navigate('/country')}
          style={{ backgroundColor: '#102234', color: 'white' }}
        >
          <FontAwesomeIcon icon={faArrowLeft} /> Back To Countries
        </button>
      </div>

      <div className="form-container">
        <h5 className="form-title">{id ? 'Edit' : 'Add'} Country Form</h5>
        <h6 className="section-title">General Details</h6>

        <form onSubmit={handleSubmit}>
          <div className="row g-4">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Name *</label>
              <input
                type="text"
                className="form-control custom-input"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Country Name"
              />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Code *</label>
              <input
                type="text"
                className="form-control custom-input"
                name="code"
                required
                value={formData.code}
                onChange={handleChange}
                placeholder="Enter Country Code"
              />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Remarks</label>
              <input
                type="text"
                className="form-control custom-input"
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
                placeholder="Enter Remarks"
              />
            </div>
            <div className="col-md-6 d-flex align-items-center gap-3 pt-4">
              <div className="form-check form-switch">
                <input
                  type="checkbox"
                  className={`form-check-input ${formData.status ? 'switch-on' : 'switch-off'}`}
                  name="status"
                  checked={formData.status}
                  onChange={handleChange}
                />
              </div>
              <label className="form-check-label fw-semibold">
                {formData.status ? 'Active' : 'Inactive'}
              </label>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-3 mt-4">
            <button
              type="button"
              className="btn btn-outline-secondary px-4 py-2 rounded-3"
              onClick={() => navigate('/country')}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-success px-4 py-2 rounded-3 shadow"
            >
              {id ? 'Update' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCountry;
